export const Theme = {
  Night: 1,
  Day: 2,
  Candy: 3,
};

export const colors = {
  [Theme.Night]: {
    bg1: "#161616",
    bg2: "#16213E",
    bgContrast: "black",
    text1: "gold",
    text2: "white",
  },
  [Theme.Day]: {
    bg1: "#EEF1FF",
    bg2: "#735CDD",
    bgContrast: "white",
    text1: "#354259",
    text2: "black",
  },
  [Theme.Candy]: {
    bg1: "#EEB76B",
    bg2: "#1597BB",
    bgContrast: "#E2703A",
    text1: "black",
    text2: "white",
  },
};

export const getColors = (theme) => colors[theme];
